import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Stack } from '@mui/material';
import { BentoThemeProvider } from '@zenput/ui-bento';

interface ConfirmFUAModalProps {
    showConfirmation: boolean;
    onSubmit: () => void;
    handleCloseConfirmation: () => void;
    _t: (translationKey: string) => string;
}

export const ConfirmFollowUpActionModal = (props: ConfirmFUAModalProps) => {
    const { showConfirmation, onSubmit, handleCloseConfirmation, _t } = props;

    return (
        <BentoThemeProvider>
            <Dialog open={showConfirmation} onClose={handleCloseConfirmation}>
                <DialogTitle>{_t('mobile_mobileform_follow_up_actions_dialog_title')}</DialogTitle>
                <DialogContent>
                    <DialogContentText sx={{ whiteSpace: 'pre-wrap' }}>
                        {_t('mobile_mobileform_follow_up_actions_dialog_subtitle')}
                    </DialogContentText>
                </DialogContent>

                <DialogActions
                    sx={{
                        justifyContent: 'center'
                    }}
                >
                    <Stack
                        sx={{
                            width: '100%'
                        }}
                        gap={2}
                    >
                        <Button variant="contained" onClick={onSubmit}>
                            {_t('mobile_mobileform_follow_up_actions_dialog_continue_button')}
                        </Button>
                        <Button variant="text" onClick={handleCloseConfirmation}>
                            {_t('mobile_common_go_back')}
                        </Button>
                    </Stack>
                </DialogActions>
            </Dialog>
        </BentoThemeProvider>
    );
};
